import {Model} from 'vue-mc';


/**
 * OutstandingInvoiceModel model
 */

export class OutstandingInvoiceModel extends Model {

	// Default attributes that define the "empty" state.
	defaults() {
		return {
			invoice_number: 0,
			invoice_date: '',
			pay_within: 0,
			invoice_amount_total: 0
		}
	}
}



// WEBPACK FOOTER //
// ./src/models/outstandingInvoiceModel.js